import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useState, useRef, useEffect } from 'react';
const Tooltip = ({ content, position = 'top', children, className = '', delay = 0 }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const triggerRef = useRef(null);
    const tooltipRef = useRef(null);
    const timeoutRef = useRef(null);
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    const calculatePosition = () => {
        if (!triggerRef.current || !tooltipRef.current)
            return;
        const triggerRect = triggerRef.current.getBoundingClientRect();
        const tooltipRect = tooltipRef.current.getBoundingClientRect();
        const spacing = 8;
        let x = 0;
        let y = 0;
        switch (position) {
            case 'top':
                x = triggerRect.left + (triggerRect.width - tooltipRect.width) / 2;
                y = triggerRect.top - tooltipRect.height - spacing;
                break;
            case 'bottom':
                x = triggerRect.left + (triggerRect.width - tooltipRect.width) / 2;
                y = triggerRect.bottom + spacing;
                break;
            case 'left':
                x = triggerRect.left - tooltipRect.width - spacing;
                y = triggerRect.top + (triggerRect.height - tooltipRect.height) / 2;
                break;
            case 'right':
                x = triggerRect.right + spacing;
                y = triggerRect.top + (triggerRect.height - tooltipRect.height) / 2;
                break;
        }
        x = Math.max(8, Math.min(x, window.innerWidth - tooltipRect.width - 8));
        y = Math.max(8, Math.min(y, window.innerHeight - tooltipRect.height - 8));
        setTooltipPosition({ x, y });
    };
    const handleMouseEnter = () => {
        if (delay > 0) {
            timeoutRef.current = setTimeout(() => {
                setIsVisible(true);
            }, delay);
        }
        else {
            setIsVisible(true);
        }
    };
    const handleMouseLeave = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsVisible(false);
    };
    const handleFocus = () => {
        handleMouseEnter();
    };
    const handleBlur = () => {
        handleMouseLeave();
    };
    useEffect(() => {
        if (isVisible) {
            calculatePosition();
        }
    }, [isVisible]);
    return (_jsxs("div", { className: `tooltip-wrapper ${className}`, children: [_jsx("div", { ref: triggerRef, className: "tooltip-trigger", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onFocus: handleFocus, onBlur: handleBlur, tabIndex: 0, children: children }), isVisible && (_jsxs("div", { ref: tooltipRef, className: `tooltip tooltip--${position} tooltip--visible`, style: {
                    left: `${tooltipPosition.x}px`,
                    top: `${tooltipPosition.y}px`,
                }, role: "tooltip", "aria-hidden": !isVisible, children: [_jsx("div", { className: "tooltip-content", children: content }), _jsx("div", { className: "tooltip-arrow" })] }))] }));
};
export default Tooltip;
